import { SquareParking } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ParkingSpotListResponse } from '@/shared/api';
import { parkingBookable } from './ObjectParkingSummary';

/**
 * Der Stellplatz-Teil in der Handy-Vorschau, so überschrieben wie auf der Aufenthaltsseite des
 * Portals. Ob wirklich ein Platz frei ist, hängt an der Buchung — die Vorschau zeigt nur, dass es
 * die Möglichkeit gibt.
 */
export function ParkingPreviewLead({
  parking,
  locale,
  failed = false,
}: {
  parking: ParkingSpotListResponse | undefined;
  locale: 'de' | 'en';
  failed?: boolean;
}) {
  const { i18n } = useTranslation();
  const t = i18n.getFixedT(locale);
  const state = parkingBookable(parking, failed);
  if (failed && !parking) {
    return (
      <p className="text-fg-mute text-xs">Stellplätze nicht geladen – dieser Teil fehlt hier.</p>
    );
  }
  if (!state.bookable) return null;
  return (
    <div className="space-y-3">
      <div>
        <p className="text-accent font-mono text-[10px] font-semibold uppercase tracking-[0.12em]">
          {t('parking.planCardTitle')}
        </p>
      </div>
      <div className="border-line bg-bg-elev flex items-center gap-3 rounded-xl border p-3">
        <SquareParking className="text-accent size-5 shrink-0" aria-hidden />
        <p className="text-fg text-xs font-semibold">
          {locale === 'en'
            ? `${state.active} ${state.active === 1 ? 'space' : 'spaces'} at the house`
            : `${state.active} ${state.active === 1 ? 'Stellplatz' : 'Stellplätze'} am Haus`}
        </p>
      </div>
      <span className="bg-accent block rounded-xl px-4 py-2.5 text-center text-xs font-semibold text-white">
        {t('parking.bookNow')}
      </span>
    </div>
  );
}
